import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { NOT_LOADED } from "../Infra/RemoteData";
import { useViewModel } from "./useViewModel";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { RequestDetailsFAQView } from "./RequestDetailsFAQView";
import { useTranslation } from "react-i18next";
import { getTranslatedStudyText } from "./TranslationService";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
import { RequestDetailsContainer, RequestDetailsTitle, ReasonForRequestSection, ReasonForRequestText, DetailsSection, DetailItem, DetailLabel, DetailValue, FAQsTitle, FAQsContainer, } from "./RequestDetailsView.styles";
export const RequestDetailsView = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientConsentViewModel, props.container);
    if (model.studyInfo === NOT_LOADED)
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    if (model.patientConsentFlow === null)
        return null;
    const study = model.studyInfo;
    const currentLanguage = i18nGetCurrentLanguage();
    function getCustomizedText(key) {
        if (!study)
            return "";
        const result = getTranslatedStudyText(study, key, currentLanguage);
        if (typeof result === "string") {
            return result;
        }
        else if (key === "purposeOfDataDisclosure" && Array.isArray(result)) {
            return result.filter((item) => item !== "Other").join(", ");
        }
        else {
            return "";
        }
    }
    function disclosureText() {
        const disclosure = getCustomizedText("purposeOfDataDisclosure");
        const other = getCustomizedText("purposeOfDataDisclosureOther");
        if (disclosure.length > 0 && other.length > 0) {
            return `${disclosure}, ${other}`;
        }
        else if (disclosure.length > 0) {
            return disclosure;
        }
        else if (other.length > 0) {
            return other;
        }
        return "";
    }
    const purposeText = model.isIAS ? null : getCustomizedText("purposeOfDataBriefEducation");
    const pageTitle = model.isIAS ? t("Frequently asked questions") : model.isAIFlow ? t("Connector FAQ") : t("Request details");
    return (_jsxs(RequestDetailsContainer, { children: [!props.hideTitle && _jsx(RequestDetailsTitle, { children: pageTitle }), purposeText && (_jsx(ReasonForRequestSection, { children: _jsx(ReasonForRequestText, { children: getCustomizedText("purposeOfDataBriefEducation") }) })), !model.isAIFlow && (_jsxs(DetailsSection, { children: [study && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Organization") }), _jsx(DetailValue, { children: study.hipaaOrganizationLegalName })] })), _jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Consent duration") }), _jsx(DetailValue, { children: t("1 year") })] }), !model.isIAS && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Request title") }), _jsx(DetailValue, { children: getCustomizedText("patientFriendlyTitle") })] })), !model.isIAS && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Purpose of request") }), _jsx(DetailValue, { children: disclosureText() })] }))] })), !model.isIAS && _jsx(FAQsTitle, { children: t("Frequently asked questions") }), _jsx(FAQsContainer, { children: _jsx(RequestDetailsFAQView, { model: model, container: props.container, onViewImage: props.onViewImage }) })] }));
});
